<template>
  <scoped>
    <div
      v-if="display"
      class="modal"
    >
      <div>
        <h1>
          {{ title }}
        </h1>
        <p v-if="message">
          {{ message }}
        </p>
        <Button
          title="Cancel"
          @click="display = false"
        />
        <Button
          title="Confirm"
          @click="callback()"
        />
      </div>
    </div>
  </scoped>
</template>

<script setup lang="ts">
  import Button from "@/components/button.vue"

  defineProps({
    callback: {
      default: null,
      required: true,
      type: Function
    },
    message: {
      default: null,
      required: false,
      type: String
    },
    title: {
      default: null,
      required: true,
      type: String
    }
  })
  
  const display = defineModel("display", {
    default: null,
    required: true,
    type: Boolean
  })
</script>

<style scoped>
  .modal {
    align-items: center;
    backdrop-filter: blur(5px);
    background-color: transparent;
    display: flex;
    flex-wrap: wrap;
    height: 100vh;
    justify-content: center;
    left: 0;
    overflow: hidden;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 1;

    > div {
      background-color: var(--color-white);
      border-color: var(--theme-color-primary);
      border-radius: var(--border-radius-big);
      border-style: solid;
      border-width: var(--border-width-bold);
      max-height: 80vh;
      max-width: 80vw;
      padding: 2em;
      z-index: 2;
    }
  }
</style>
